const StarRating = ({ rating, count, size = 'sm' }) => {
  const sz = size === 'md' ? 'w-4 h-4' : 'w-3 h-3';
  return (
    <div className="flex items-center gap-1">
      <div className="flex">
        {[1,2,3,4,5].map(i => {
          const filled = i <= Math.floor(rating);
          const half   = !filled && i - 0.5 <= rating;
          return (
            <svg key={i} className={`${sz} ${filled || half ? 'text-amber-400' : 'text-gray-200'}`}
              fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
            </svg>
          );
        })}
      </div>
      {count !== undefined && count !== null && (
        <span className="text-[11px] text-ink-muted">({count.toLocaleString('en-IN')})</span>
      )}
    </div>
  );
};

export default StarRating;
